export const withoutCmsBlocks = <T extends { cmsBlocks: unknown }>({
    cmsBlocks: _cmsBlocks,
    ...rest
}: T): Omit<T, 'cmsBlocks'> => rest
